module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Audit " + _vm._s(_vm.getDatasetDisplayType(_vm.recordData.dataSetType)) + "\n      "), (_vm.showAutoSave) ? _c('span', {
    staticClass: "autosave-notification"
  }, [_vm._m(0), _vm._v("\n         Saving...\n      ")]) : _vm._e()]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_vm._m(1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.getDatasetDisplayType(_vm.recordData.dataSetType)) + " Audit")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "file-display-div"
  }, [_c('strong', [_vm._v("File name: ")]), _vm._v(_vm._s(_vm.recordData.fileName) + "\n            "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Gender count: ")]), _vm._v(" Women - " + _vm._s(_vm.womenCount) + ", Men - " + _vm._s(_vm.menCount) + "\n          ")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-xs-12 col-md-12 col-lg-12 audit-symptoms-table"
  }, [(_vm.recordData.dataSetType !== 'chat-intent') ? _c('div', [_c('vue-good-table', {
    attrs: {
      "styleClass": "vgt-table good-table condensed striped",
      "columns": _vm.getColumns(),
      "rows": _vm.dataSetData,
      "pagination-options": {
        enabled: true,
        perPage: 15,
        perPageDropdown: [10, 15, 20, 50, 100]
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_vm._t("default", null, {
          "props": props
        }), _vm._v(" "), (props.column.field == 'manual_classifier') ? _c('span', {
          staticStyle: {
            "max-width": "33%"
          }
        }, [_c('treeselect', {
          attrs: {
            "placeholder": "--Choose or Enter tag--",
            "multiple": true,
            "defaultOptions": true,
            "load-options": _vm.loadOptions,
            "async": true,
            "clearOnSelect": true,
            "id": "tag",
            "search-nested": "",
            "cacheOptions": false
          },
          on: {
            "select": function($event) {
              return _vm.addNewSource($event, props)
            },
            "input": function($event) {
              return _vm.onTagChange(props)
            },
            "close": _vm.autoSaveDataSet,
            "open": _vm.handleOpen
          },
          scopedSlots: _vm._u([{
            key: "value-label",
            fn: function(ref) {
              var node = ref.node;

              return _c('div', {}, [_vm._v(_vm._s(node.raw.customlabel))])
            }
          }], null, true),
          model: {
            value: (_vm.recordData.dataSet[props.row.tableIndex].manual_classifier),
            callback: function($$v) {
              _vm.$set(_vm.recordData.dataSet[props.row.tableIndex], "manual_classifier", $$v)
            },
            expression: "recordData.dataSet[props.row.tableIndex].manual_classifier"
          }
        })], 1) : (props.column.field == 'action') ? _c('span', {
          staticStyle: {
            "white-space": "pre-line"
          }
        }, [_vm._v(_vm._s(_vm.getActionText(props)))]) : _c('span', {
          staticStyle: {
            "white-space": "pre-line",
            "word-break": "break-word",
            "text-align": "left",
            "float": "left"
          }
        }, [_vm._v(_vm._s(props.formattedRow[props.column.field]))])]
      }
    }], null, true)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_c('nv-empty-state', {
    attrs: {
      "icon": "fa-heartbeat",
      "title": "No records found",
      "hint": "Try changing the filters."
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "loadingContent"
  })], 2)], 1) : _c('div', {
    staticClass: "audit-chat-intent-table"
  }, [_c('vue-good-table', {
    attrs: {
      "styleClass": "vgt-table good-table condensed striped",
      "columns": _vm.chatIntentColumns,
      "rows": _vm.dataSetData,
      "max-height": "74vh",
      "fixed-header": true,
      "pagination-options": {
        enabled: true,
        perPage: 15,
        perPageDropdown: [10, 15, 20, 50, 100]
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_vm._t("default", null, {
          "props": props
        }), _vm._v(" "), (props.column.field == 'manual_classifier') ? _c('span', {
          staticStyle: {
            "max-width": "33%"
          }
        }, [_c('div', {
          staticClass: "row chat-intent-classifier"
        }, [_c('strong', {
          staticStyle: {
            "white-space": "pre"
          }
        }, [_vm._v("Classifier: ")]), _vm._v(" "), _c('treeselect', {
          attrs: {
            "placeholder": "--Choose or Enter tag--",
            "options": _vm.referralSource,
            "search-nested": ""
          },
          on: {
            "select": function($event) {
              return _vm.addNewSource($event, props)
            },
            "input": function($event) {
              return _vm.changeClassifier(_vm.recordData.dataSet[props.row.tableIndex])
            }
          },
          scopedSlots: _vm._u([{
            key: "value-label",
            fn: function(ref) {
              var node = ref.node;

              return _c('div', {}, [_vm._v(_vm._s(node.raw.customlabel))])
            }
          }], null, true),
          model: {
            value: (_vm.recordData.dataSet[props.row.tableIndex].manual_classifier),
            callback: function($$v) {
              _vm.$set(_vm.recordData.dataSet[props.row.tableIndex], "manual_classifier", $$v)
            },
            expression: "recordData.dataSet[props.row.tableIndex].manual_classifier"
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "row chat-intent-classifier"
        }, [_c('strong', {
          staticStyle: {
            "white-space": "pre"
          }
        }, [_vm._v("Response: ")]), _vm._v(" " + _vm._s(_vm.recordData.dataSet[props.row.tableIndex].response ? _vm.recordData.dataSet[props.row.tableIndex].response : ' No response') + "\n                        ")])]) : (props.column.field == 'action') ? _c('span', {
          staticStyle: {
            "text-align": "start"
          }
        }, [_c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-12 col-lg-12 col-xs-12"
        }, [_c('label', {
          staticClass: "checkbox-inline"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.recordData.dataSet[props.row.tableIndex].action.wrong_classification),
            expression: "recordData.dataSet[props.row.tableIndex].action.wrong_classification"
          }],
          attrs: {
            "disabled": "",
            "type": "checkbox",
            "name": "autoaccepttnc",
            "id": "autoaccepttnc"
          },
          domProps: {
            "checked": Array.isArray(_vm.recordData.dataSet[props.row.tableIndex].action.wrong_classification) ? _vm._i(_vm.recordData.dataSet[props.row.tableIndex].action.wrong_classification, null) > -1 : (_vm.recordData.dataSet[props.row.tableIndex].action.wrong_classification)
          },
          on: {
            "change": function($event) {
              var $$a = _vm.recordData.dataSet[props.row.tableIndex].action.wrong_classification,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(_vm.recordData.dataSet[props.row.tableIndex].action, "wrong_classification", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(_vm.recordData.dataSet[props.row.tableIndex].action, "wrong_classification", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(_vm.recordData.dataSet[props.row.tableIndex].action, "wrong_classification", $$c)
              }
            }
          }
        }), _vm._v("Wrong Classification\n                                              ")])])]), _vm._v(" "), _c('div', {
          staticClass: "row"
        }, [_c('div', {
          staticClass: "col-md-12 col-lg-12 col-xs-12"
        }, [_c('label', {
          staticClass: "checkbox-inline"
        }, [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.recordData.dataSet[props.row.tableIndex].action.bad_response),
            expression: "recordData.dataSet[props.row.tableIndex].action.bad_response"
          }],
          attrs: {
            "type": "checkbox",
            "name": "customMessages",
            "id": "customMessages"
          },
          domProps: {
            "checked": Array.isArray(_vm.recordData.dataSet[props.row.tableIndex].action.bad_response) ? _vm._i(_vm.recordData.dataSet[props.row.tableIndex].action.bad_response, null) > -1 : (_vm.recordData.dataSet[props.row.tableIndex].action.bad_response)
          },
          on: {
            "change": [function($event) {
              var $$a = _vm.recordData.dataSet[props.row.tableIndex].action.bad_response,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(_vm.recordData.dataSet[props.row.tableIndex].action, "bad_response", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(_vm.recordData.dataSet[props.row.tableIndex].action, "bad_response", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(_vm.recordData.dataSet[props.row.tableIndex].action, "bad_response", $$c)
              }
            }, _vm.autoSaveDataSet]
          }
        }), _vm._v("Bad Response\n                                              ")])])])]) : _c('span', {
          staticStyle: {
            "white-space": "pre-line",
            "word-break": "break-word",
            "text-align": "left",
            "float": "left"
          }
        }, [_vm._v(_vm._s(props.formattedRow[props.column.field]))])]
      }
    }], null, true)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_c('nv-empty-state', {
    attrs: {
      "icon": "fa-comments-o",
      "title": "No records found",
      "hint": "Try changing the filters."
    }
  })], 1), _vm._v(" "), _c('template', {
    slot: "loadingContent"
  })], 2)], 1)])]), _vm._v(" "), (_vm.showAutoSave) ? _c('span', {
    staticClass: "autosave-notification-bottom"
  }, [_vm._m(2), _vm._v("\n               Saving...\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "audit-save-btn"
  }, [_c('router-link', {
    attrs: {
      "to": ("/auditing/" + (_vm.recordData.dataSetType))
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin": "30px 0px"
    },
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Go back")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin": "30px 0px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updateDataSet
    }
  }, [_vm._v("Submit Actions")])], 1)])])])]), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    staticClass: "fa fa-refresh rotate",
    staticStyle: {
      "font-size": "17px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', {
    staticClass: "fa fa-refresh rotate",
    staticStyle: {
      "font-size": "17px"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-6ec3086b","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auditing/audit.vue
// module id = W612
// module chunks = 1